import { normalizeAngle, getPolar, degToRad, radToDeg, getOffsetAngle } from '../../utils/math';
import measureText from '../../utils/measureText';
import * as lodash from '../../utils/lodash';
function pieLabelLayout(pieSeriesModel, _a) {
    var labelOption = _a.labelOption, labelIndex = _a.labelIndex;
    var state = pieSeriesModel.getState();
    var cx = state.cx, cy = state.cy, radius = state.radius, points = state.points;
    var option = pieSeriesModel.getOption();
    var distance = labelOption.distance, fontSize = labelOption.fontSize, lineHeight = labelOption.lineHeight;
    var rich = labelOption.rich;
    var leadLength = option.connectLine.leadLength;
    var topLeftPoints = [];
    var topRightPoints = [];
    var bottomLeftPoints = [];
    var bottomRightPoints = [];
    points.forEach(function (point) {
        var midAngle = point.midAngle;
        var angle = normalizeAngle(midAngle);
        if (angle >= 0 && angle < 90) {
            bottomRightPoints.push(point);
        }
        else if (angle >= 90 && angle < 180) {
            bottomLeftPoints.push(point);
        }
        else if (angle >= 180 && angle < 270) {
            topLeftPoints.push(point);
        }
        else {
            topRightPoints.push(point);
        }
    });
    [topLeftPoints, topRightPoints, bottomLeftPoints, bottomRightPoints].forEach(function (sidePoints) {
        return sidePoints.sort(function (a, b) {
            return normalizeAngle(a.midAngle) - normalizeAngle(b.midAngle);
        });
    });
    var polar = getPolar({ cx: cx, cy: cy });
    var labelRadius = radius + distance;
    function adjustY(sidePoints, vside) {
        var prevY;
        sidePoints.forEach(function (point, index) {
            var y = point.labelPosition[labelIndex].y;
            if (index === 0) {
                //
            }
            else {
                var gap = point.labelHeight;
                if (vside === 'top' && prevY - y < gap) {
                    y = prevY - gap;
                }
                else if (vside === 'bottom' && y - prevY < gap) {
                    y = prevY + gap;
                }
            }
            point.labelPosition[labelIndex].y = y;
            prevY = y;
        });
    }
    function adjustX(sidePoints, hside) {
        sidePoints.forEach(function (point) {
            var labelPosition = point.labelPosition;
            var _a = labelPosition[labelIndex], x = _a.x, y = _a.y;
            var offsetY = y - cy;
            var toCenterDistance = Math.sqrt(Math.pow(x - cx, 2) + Math.pow(y - cy, 2));
            if (toCenterDistance - labelRadius > 1) {
                var offsetAngle = getOffsetAngle(x - cx, y - cy);
                var offsetRadius = Math.sqrt(Math.pow(x - cx, 2) + Math.pow(y - cy, 2));
                point.labelPosition[labelIndex].x = cx + Math.cos(degToRad(offsetAngle)) * offsetRadius;
            }
            else if (toCenterDistance - labelRadius < -1) {
                var angle = Math.asin(offsetY / labelRadius);
                point.labelPosition[labelIndex].x =
                    cx + labelRadius * Math.cos(angle) * (hside === 'left' ? -1 : 1);
            }
        });
    }
    function initPointSizeAndPosition(sidePoints, hside) {
        sidePoints.forEach(function (point) {
            var midAngle = point.midAngle;
            var name = pieSeriesModel.getDataLabel(point.dataIndex, labelOption);
            if (point.visible && name) {
                point.labelHeight = rich
                    ? measureText(name, labelOption).height
                    : (name + '').split('\n').length * (lineHeight || fontSize);
                point.labelWidth = measureText(name, labelOption).width;
            }
            else {
                point.labelHeight = 0;
                point.labelWidth = 0;
            }
            var rotate = Math.asin((Math.sin(degToRad(midAngle)) * leadLength) / labelRadius) *
                (hside === 'right' ? -1 : 1);
            point.labelPosition[labelIndex] = polar(point.midAngle + radToDeg(rotate), labelRadius);
        });
    }
    function avoidOverlap(sidePoints, vside, hside) {
        if (!sidePoints.length) {
            return;
        }
        if (labelOption.autoHide) {
            return;
        }
        var minY = cy;
        if (vside === 'bottom') {
            var firstPoint = sidePoints[0];
            var sameSidePoints = hside === 'left' ? topLeftPoints : topRightPoints;
            if (sameSidePoints.length) {
                var minTop = lodash.max(sameSidePoints.map(function (point) { return point.labelPosition[labelIndex].y; })) +
                    firstPoint.labelHeight;
                minY = Math.max(minTop, cy);
                if (firstPoint.labelPosition[labelIndex].y < minTop) {
                    firstPoint.labelPosition[labelIndex].y = minTop;
                }
            }
        }
        adjustY(sidePoints, vside);
        var lastY = lodash.last(sidePoints).labelPosition[labelIndex].y;
        var offsetY = Math.abs(lastY - cy);
        if (offsetY > labelRadius) {
            var space_1 = offsetY - labelRadius;
            var leftSpace_1 = 0;
            var clampIndex = 0;
            var reversePoints = sidePoints
                .slice(0)
                .reverse()
                .filter(function (point) { return point.visible; });
            for (var i = 0; i < reversePoints.length; i++) {
                var point = reversePoints[i];
                var labelHeight = point.labelHeight, labelPosition = point.labelPosition;
                if (reversePoints[i + 1]) {
                    var prevY = reversePoints[i + 1].labelPosition[labelIndex].y;
                    leftSpace_1 += Math.abs(labelPosition[labelIndex].y - prevY) - labelHeight;
                }
                else {
                    leftSpace_1 += Math.abs(labelPosition[labelIndex].y - cy);
                }
                clampIndex = i;
                if (leftSpace_1 > space_1) {
                    break;
                }
            }
            var basePoint_1 = reversePoints[clampIndex + 1];
            var baseY = basePoint_1 ? basePoint_1.labelPosition[labelIndex].y : minY;
            if (leftSpace_1 > space_1) {
                baseY += (leftSpace_1 - space_1) * (vside === 'top' ? -1 : 1);
            }
            reversePoints
                .slice(0, clampIndex + 2)
                .reverse()
                .reduce(function (prev, current, curretIndex) {
                // enough space
                if (!(leftSpace_1 > space_1 && basePoint_1 && curretIndex === 0)) {
                    current.labelPosition[labelIndex].y = prev;
                }
                return prev + current.labelHeight * (vside === 'top' ? -1 : 1);
            }, baseY);
        }
        adjustX(sidePoints, hside);
    }
    var pointGroups = [
        [topLeftPoints, 'top', 'left'],
        [topRightPoints.reverse(), 'top', 'right'],
        [bottomLeftPoints.reverse(), 'bottom', 'left'],
        [bottomRightPoints, 'bottom', 'right'],
    ];
    pointGroups.forEach(function (group) {
        initPointSizeAndPosition(group[0], group[2]);
        avoidOverlap(group[0], group[1], group[2]);
    });
}
export default pieLabelLayout;
